module.exports = __webpack_public_path__ + "img/4.e2fc6cc3.jpg";